export default function DevicesService($http, appSettings) {
  'ngInject';
  return {
    getAllDevices: function () {
      return $http.get(appSettings.IcebergApiDevicesEndpoint + '/devices/');
    },
    getDevice: function (serialNumber) {
      return $http.get(appSettings.IcebergApiDevicesEndpoint + '/devices/' + serialNumber);
    },
    getDeviceModelBySerialNumber: function (telematicsSerialNumber) {
      var endpoint = appSettings.IcebergApiDevicesEndpoint + '/models/' + telematicsSerialNumber;
      return $http.get(endpoint);
    }
  };
}